/**
 * Time & Attendance — Approvals quick start (managers / HR).
 */

export const PEOPLE_APPROVALS_TOUR_ID = "people-approvals-v1";

export const PEOPLE_APPROVALS_TOUR_STEPS = [
  {
    id: "filters",
    route: "/people/approvals",
    selector: "[data-tour='approvals-filters']",
    title: "Filter the inbox",
    description:
      "Switch between all pending items, leave, telework, and timesheets. Counts update as you approve or reject.",
    placement: "bottom",
  },
  {
    id: "list",
    route: "/people/approvals",
    selector: "[data-tour='approvals-list']",
    title: "Review and decide",
    description:
      "Each card is one request. Approve in one click, or reject with a reason. For timesheets you can expand hours by job before deciding.",
    placement: "top",
  },
];
